import React from "react";
import { Fragment } from "react";
import { Col, Container, Row } from "reactstrap";

const Footer = () => {
  return (
    <Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md="12" className="footer-copyright text-center"></Col>
          </Row>
        </Container>
      </footer>
    </Fragment>
  );
};

export default Footer;
